import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CreditosService } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-creatarifa',
  templateUrl: './creatarifa.component.html',
  styleUrls: []
})
export class CreatarifaComponent implements OnInit {

  forma: FormGroup;
  ido: string;
  service: any[] = [];
  condiciones: any[] = [];
  periodospagos: any[] = [];
  calificacioncreditos: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private creditosService: CreditosService,
    public router: Router
  ) { }


  ngOnInit() {
    this.creditosService.getCondiciones().subscribe( resp => { this.condiciones = resp; console.log(resp)} );
    this.creditosService.getperiodosPagos().subscribe ( resp => this.periodospagos = resp )
    this.creditosService.getCalificacionCreditos().subscribe( resp => this.calificacioncreditos = resp )
    this.forma = new FormGroup({
      Key: new FormControl( null , Validators.required ),
      Descripcion: new FormControl( null , Validators.required )

    } );
  }


  CreaTarifa() {

    // Obtener el elemento por el id
    const Key: any = document.getElementById('Key');
    const Descripcion: any = document.getElementById('Descripcion');
    const Valor: any = document.getElementById('Valor');
    const Condicion: any = document.getElementById('Condicion');
    const Periodospago: any = document.getElementById('Periodospago');
    const Calificacioncredito: any = document.getElementById('Calificacioncredito');
    // Obtener el valor de la opción seleccionada

    const valorKey = Key.value;
    const valorDescripcion = Descripcion.value;
    const valorValor = Valor.value;
    const valorCondicion = Condicion.value
    const valorPeriodospago = Periodospago.value
    const valorCalificacioncredito = Calificacioncredito.value

    const params = {
      key: valorKey,
      description: valorDescripcion,
      value: valorValor,
      term_id: valorCondicion,
      payment_period_id: valorPeriodospago,
      credit_rating_id: valorCalificacioncredito,
      secret_key: '',
      token: ''
    }

    this.creditosService.crearRate( params ).subscribe( () => {
    Swal.fire({
      title: 'Creacion de tarifa exitosa',
      text: '',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this.router.navigate(['/panelcontrol/tarifas']);
      }

    } );

  }, (err) => {            // console.clear();
    // console.log(err);
                            Swal.fire(
                              'Ocurrio un error',
                              'Error',
                              'error'
                           );
                        } ); 

  }

}
